import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { TRADE_IN_APPRAISER_HEADER } from 'site-modules/shared/constants/appraisal/appraisal';

export function TradeInAppraiserHeader({ headerText = '', subHeaderText = '', isExtendedReport = false }) {
  if (isExtendedReport) return null;

  return (
    <Row className="mb-2">
      <Col xs={12} className="text-gray-darker" name={TRADE_IN_APPRAISER_HEADER}>
        <h2 className="mb-0">{headerText}</h2>
        <div className="fw-normal mb-0">{subHeaderText}</div>
      </Col>
    </Row>
  );
}
TradeInAppraiserHeader.propTypes = {
  headerText: PropTypes.string,
  subHeaderText: PropTypes.string,
  isExtendedReport: PropTypes.bool,
};
